/* Le classi condivise da /servizi/monitoraggio. Stanno in un modulo senza
   direttiva perché le leggono sia la pagina (Server Component) sia il
   selettore degli ambiti («use client»): una costante esportata da un file
   client e letta dal server non è il suo valore (vedi LEAD_DISPACCI nei
   learnings). Le legge anche /servizi/report, che ha la stessa struttura. */

import { FUOCO_HOME } from "@/components/home/stile";

/** Il pulsante pieno blu del modello (`.btn`): Geist 14/600, 13 × 20. */
export const PULSANTE =
  "inline-flex items-center rounded-[2px] bg-mare px-5 py-[13px] font-sans text-corpo font-semibold text-suMare no-underline transition-opacity hover:opacity-90 " +
  FUOCO_HOME;

/** Il riquadro di un passaggio (`.m-p`): superficie, bordo inchiostro,
 *  40 di rientro in cima per lasciare posto al rombo. */
const RIQUADRO = "flex flex-col gap-3.5 overflow-hidden border border-ink bg-surface pt-10";
export const RIQUADRO_PASSO = `${RIQUADRO} px-[26px]`;
/** La fase del Report (`.m-p.r-fase`): lo stesso riquadro, più stretto ai
 *  lati perché le colonne sono cinque, e con 22 di rientro in fondo. */
export const RIQUADRO_FASE = `${RIQUADRO} px-[22px] pb-[22px]`;
/** L'etichetta numerata (`.m-p .n`): mono 12 maiuscolo rame. */
export const NUMERO_PASSO = "m-0 font-mono text-meta tracking-[0.08em] text-segnale uppercase";
/** La nota in fondo al testo (`.m-p .nota`): Geist 15 sonda. */
export const NOTA_PASSO = "m-0 font-sans text-sommario leading-[1.55] text-sommesso";
